/**
 * Account Form Modal Component
 *
 * Modal wrapper for account creation/editing form.
 */

import React from 'react';
import { Modal } from '@/shared/ui/components/Modal';
import { Button } from '@/shared/ui/components/Button';
import { AccountFormFields } from './AccountFormFields';
import type { AccountFormState } from '../model/types';

interface AccountFormModalProps {
  state: AccountFormState;
}

export const AccountFormModal: React.FC<AccountFormModalProps> = ({ state }) => {
  const { mode, formData, isSubmitting, close, updateFormData, submit } = state;

  if (!mode) return null;

  const isAdd = mode === 'add';
  const title = isAdd ? '새 계정 추가' : '계정 수정';
  const submitLabel = isAdd ? '추가' : '수정';

  return (
    <Modal isOpen={true} onClose={close}>
      <div className="p-6">
        <h3 className="text-lg font-semibold mb-4">{title}</h3>

        <form
          className="space-y-4"
          onSubmit={(e) => {
            e.preventDefault();
            submit();
          }}
        >
          <AccountFormFields formData={formData} onUpdate={updateFormData} mode={mode} />

          <div className="flex justify-end space-x-3 mt-6">
            <Button type="button" variant="outline" onClick={close} disabled={isSubmitting}>
              취소
            </Button>
            <Button type="submit" disabled={isSubmitting}>
              {isSubmitting ? `${submitLabel} 중...` : submitLabel}
            </Button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

AccountFormModal.displayName = 'AccountFormModal';
